var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image" }, [
    _c("img", {
      class: {
        bigImage: _vm.field.type === "bigimage",
        smallImage: _vm.field.type === "smallimage"
      },
      attrs: { src: _vm.element[_vm.field.value] }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }